import React from 'react'
import ReactDOM from 'react-dom'
import { ChainEditor } from './ChainEditor'

export const startChainEditor = (containerId, options) => {
  const container = document.getElementById(containerId)
  if (!container) {
    console.error(`ChainEditor: container "#${containerId}" not found`)
    return
  }

  ReactDOM.render(
    <ChainEditor
      stepsTextareaId={options.stepsTextareaId}
      simulationsDataId={options.simulationsDataId}
      coursenum={options.coursenum}
    />,
    container
  )
}
